export const selectAvailableLanguages = (state) => state?.availableLanguages?.languages
